import DOMPurify from 'isomorphic-dompurify';
import * as React from 'react';

// Initially adapted from demo sanitisation usage from https://stackoverflow.com/a/60797348/2803757
const defaultOptions = {
  // Whitelist based off: https://github.com/github/markup/issues/245#issuecomment-682231577
  ALLOWED_TAGS: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'h7', 'h8', 'br', 'b', 'i', 'strong', 'em', 'a', 'pre', 'code', 'img', 'tt', 'div', 'ins', 'del', 'sup', 'sub', 'p', 'ol', 'ul', 'table', 'thead', 'tbody', 'tfoot', 'blockquote', 'dl', 'dt', 'dd', 'kbd', 'q', 'samp', 'var', 'hr', 'ruby', 'rt', 'rp', 'li', 'tr', 'td', 'th', 's', 'strike', 'summary', 'details', 'caption', 'figure', 'figcaption', 'abbr', 'bdo', 'cite', 'dfn', 'mark', 'small', 'span', 'time', 'wbr'],
  ALLOWED_ATTR: ['href'] // TODO automatically make links open new tabs with safe `rel`?
};

DOMPurify.addHook("afterSanitizeAttributes", (node: any, data) => {
  if (node.tagName === "IFRAME") {
    node.setAttribute("sandbox", "allow-same-origin allow-scripts");
    node.setAttribute("loading", "lazy");
  }
  if (node.tagName === 'A') {
    if (node.getAttribute('href')?.includes('https://successatschool.org/')) {
      node.setAttribute('rel', 'noopener noreferrer');
      node.setAttribute('target', '_blank');
    }
  }
});
const sanitize = (dirty, options = {}) => ({
  __html: (DOMPurify.sanitize(dirty, {
    ...defaultOptions,
    ...options
  }) as string)
});
export const SanitizeHTML = ({
  html,
  options = {
    USE_PROFILES: {
      html: true
    },
    ADD_TAGS: ["iframe"],
    ADD_ATTR: ["allow", "allowfullscreen", "frameborder", "scrolling"]
  },
  ...props
}) => <div dangerouslySetInnerHTML={sanitize(html, options)} {...props} data-sentry-component="SanitizeHTML" data-sentry-source-file="string.tsx" />;